import { BankData, BankQuestionData, BankQuestionType } from "lms/types/questionBank";
import { BankCardData } from 'lms/types/questionBank';

export const bankQuestionsMock: BankQuestionData[] = [
    {
        id: "q1",
        index: 1,
        text: "What is the capital of France?",
        type: BankQuestionType.multiple,
        options: [
            { index: 1, text: "Paris", correct: true },
            { index: 2, text: "Rome" },
            { index: 3, text: "Berlin" },
            { index: 4, text: "Madrid" },
        ]
    },
    {
        id: "q2",
        index: 2,
        text: "Match the following countries with their capitals.",
        type: BankQuestionType.relation,
        options: [
            { index: 1, text: "France", explanation: "Paris" },
            { index: 2, text: "Italy", explanation: "Rome" },
            { index: 3, text: "Germany", explanation: "Berlin" },
            { index: 4, text: "Spain", explanation: "Madrid" }
        ]
    },
    {
        id: "q3",
        index: 3,
        text: "How satisfied are you with our service?",
        type: BankQuestionType.survey,
        options: [
            { index: 1, text: "Very satisfied" },
            { index: 2, text: "Satisfied" },
            { index: 3, text: "Neutral" },
            { index: 4, text: "Dissatisfied" },
            { index: 5, text: "Very dissatisfied" }
        ]
    },
    {
        id: "q4",
        index: 4,
        text: "Which of the following is a programming language?",
        type: BankQuestionType.multiple,
        options: [
            { index: 1, text: "JavaScript", correct: true },
            { index: 2, text: "HTML" },
            { index: 3, text: "CSS" },
            { index: 4, text: "SQL" }
        ]
    },
    {
        id: "q5",
        index: 5,
        text: "Which of these are renewable energy sources?",
        type: BankQuestionType.multiple,
        options: [
            { index: 1, text: "Solar", correct: true },
            { index: 2, text: "Wind" },
            { index: 3, text: "Coal" },
            { index: 4, text: "Oil" }
        ]
    }
];

export const banksMock: BankCardData[] = [
    {
        id: "1",
        name: "Mathematics Basics",
        description: "A set of basic arithmetic and algebra questions.",
        questionTypes: [BankQuestionType.multiple, BankQuestionType.survey],
        questionCount: 15,
        updatedAt: "2024-09-20T10:30:00Z",
        coursesInUse: [
            { id: '1', name: 'Math' },
            { id: '2', name: 'Introduction to Quantum Physics' },
            { id: '3', name: 'History' },
            { id: '4', name: 'Advanced Theoretical Computer Science' },
            { id: '5', name: 'Art' },
            { id: '6', name: 'Environmental Sustainability' },
            { id: '7', name: 'Short' },
            { id: '8', name: 'Human Psychology and Behavioral Studies' },
            { id: '9', name: 'Data Structures' },
            { id: '10', name: 'AI in Healthcare and Medicine' },
            { id: '71', name: 'Short' },
            { id: '11', name: 'Comprehensive Guide to Machine Learning and Artificial Intelligence' },
            { id: '21', name: 'Advanced Topics in Quantum Computing and Cryptography Applications' },
            { id: '31', name: 'Deep Dive into Neuroscience: Brain Functionality and Cognitive Science' },
            { id: '41', name: 'Exploring the Frontiers of Astrobiology and Extraterrestrial Life Research' },
            { id: '51', name: 'Strategic Management in the Era of Digital Transformation and Innovation' },
            { id: '13', name: 'Quantum Field Theory' },
            { id: '23', name: 'Neuroscience of Decision Making' },
            { id: '33', name: 'Modern Art and Visual Culture' },
            { id: '43', name: 'Advanced Data Science and Machine Learning' },
            { id: '53', name: 'Philosophy of Science' },
            { id: '63', name: 'Environmental Economics' },
            { id: '73', name: 'Global Health and Infectious Diseases' },
            { id: '83', name: 'Cognitive Psychology' },
            { id: '93', name: 'Digital Marketing Strategies' },
            { id: '103', name: 'Bioinformatics and Computational Biology' }
        ]
    },
    {
        id: "2",
        name: "World Geography",
        description: "Test your knowledge on world maps, capitals, and geography.",
        questionTypes: [BankQuestionType.relation],
        questionCount: 25,
        updatedAt: "2024-09-21T12:15:00Z",
        coursesInUse: [
            { id: '7', name: 'Short' },
            { id: '1', name: 'Comprehensive Guide to Machine Learning and Artificial Intelligence' },
            { id: '2', name: 'Advanced Topics in Quantum Computing and Cryptography Applications' },
            { id: '3', name: 'Deep Dive into Neuroscience: Brain Functionality and Cognitive Science' },
            { id: '4', name: 'Exploring the Frontiers of Astrobiology and Extraterrestrial Life Research' },
            { id: '5', name: 'Strategic Management in the Era of Digital Transformation and Innovation' }
        ]
    },
    {
        id: "3",
        name: "Customer Feedback Survey",
        description: "A comprehensive survey on customer satisfaction and feedback.",
        questionTypes: [BankQuestionType.survey],
        questionCount: 10,
        updatedAt: "2024-09-18T08:45:00Z",
        coursesInUse: [
            { id: '1', name: 'Comprehensive Guide to Machine Learning and Artificial Intelligence' },
            { id: '2', name: 'Advanced Topics in Quantum Computing and Cryptography Applications' },
        ]
    },
    {
        id: "4",
        name: "Physics Advanced",
        description: "Challenging questions covering classical mechanics and electromagnetism.",
        questionTypes: [BankQuestionType.multiple],
        questionCount: 40,
        updatedAt: "2024-09-22T09:30:00Z",
        coursesInUse: [
            { id: '1', name: 'Math' },
            { id: '2', name: 'Introduction to Quantum Physics' },
            { id: '3', name: 'History' },
            { id: '10', name: 'AI in Healthcare and Medicine' }
        ]
    },
    {
        id: "5",
        name: "Programming Languages",
        description: "Multiple choice questions on programming languages such as Python, Java, and JavaScript.",
        questionTypes: [BankQuestionType.multiple],
        questionCount: 30,
        updatedAt: "2024-09-19T14:00:00Z",
        coursesInUse: [
            { id: '1', name: 'Algebraic Topology' },
            { id: '2', name: 'Introduction to Philosophy' }
        ]
    },
    {
        id: "6",
        name: "Logic & Problem Solving",
        description: "Questions to test your logical reasoning and problem-solving skills.",
        questionTypes: [BankQuestionType.multiple, BankQuestionType.relation],
        questionCount: 20,
        updatedAt: "2024-09-17T16:30:00Z",
        coursesInUse: [{ id: '1', name: 'Linear Algebra' },
        { id: '2', name: 'Global Political Economy' },
        { id: '3', name: 'Artificial Intelligence for Robotics' },
        { id: '4', name: 'Principles of Microeconomics' }]

    },
    {
        id: "7",
        name: "Art History",
        description: "Explore art movements and their significant pieces throughout history.",
        questionTypes: [BankQuestionType.multiple, BankQuestionType.survey],
        questionCount: 18,
        updatedAt: "2024-09-18T11:00:00Z",
        coursesInUse: [
            { id: '1', name: 'Classical Mechanics' },
            { id: '2', name: 'Contemporary Literature' },
            { id: '3', name: 'Biostatistics' },
            { id: '4', name: 'Blockchain in Business' },
            { id: '5', name: 'Space Science and Exploration' },
            { id: '6', name: 'Ethical Hacking and Cybersecurity' }
        ]
    },
    {
        id: "8",
        name: "Music Theory",
        description: "Learn and test knowledge on scales, chords, and music notation.",
        questionTypes: [BankQuestionType.survey, BankQuestionType.relation],
        questionCount: 12,
        updatedAt: "2024-09-15T13:20:00Z",
        coursesInUse: [
            { id: '1', name: 'Software Engineering Principles' },
            { id: '2', name: 'Astrophysics and Cosmology' },
            { id: '3', name: 'International Business Strategies' },
            { id: '4', name: 'Behavioral Economics' },
            { id: '5', name: 'Creative Writing and Storytelling' },
            { id: '6', name: 'Introduction to Marine Biology' },
            { id: '7', name: 'Cyber-Physical Systems' },
            { id: '8', name: 'Global Climate Change Policy' }
        ]
    },
    {
        id: "9",
        name: "Project Management Principles",
        description: "Questions on project management methodologies such as Agile and Scrum.",
        questionTypes: [BankQuestionType.survey],
        questionCount: 22,
        updatedAt: "2024-09-13T15:40:00Z",
        coursesInUse: [
            { id: '1', name: 'Quantum Field Theory' },
            { id: '2', name: 'Neuroscience of Decision Making' },
            { id: '3', name: 'Modern Art and Visual Culture' },
            { id: '4', name: 'Advanced Data Science and Machine Learning' },
            { id: '5', name: 'Philosophy of Science' },
            { id: '6', name: 'Environmental Economics' },
            { id: '7', name: 'Global Health and Infectious Diseases' },
            { id: '8', name: 'Cognitive Psychology' },
            { id: '9', name: 'Digital Marketing Strategies' },
            { id: '10', name: 'Bioinformatics and Computational Biology' }
        ]
    },
    {
        id: "10",
        name: "Environmental Science",
        description: "A broad survey of ecological principles and environmental impact topics.",
        questionTypes: [BankQuestionType.multiple, BankQuestionType.relation],
        questionCount: 50,
        updatedAt: "2024-09-23T09:50:00Z",
        coursesInUse: [
            { id: '1', name: 'Math' },
            { id: '2', name: 'Introduction to Quantum Physics' },
            { id: '3', name: 'History' },
            { id: '4', name: 'Advanced Theoretical Computer Science' },
            { id: '5', name: 'Art' },
            { id: '6', name: 'Environmental Sustainability' },
            { id: '7', name: 'Short' },
            { id: '8', name: 'Human Psychology and Behavioral Studies' },
            { id: '9', name: 'Data Structures' },
            { id: '10', name: 'AI in Healthcare and Medicine' }
        ]
    },
    {
        id: "11",
        name: "Comprehensive Exploration of Advanced Quantum Mechanics and Theoretical Physics in a Post-Classical Framework",
        description: "This question bank covers a vast array of topics within the field of quantum mechanics, delving deep into the theoretical aspects that govern particle behavior at a microscopic level, including wave-particle duality, quantum entanglement, and the mathematical formalism of quantum operators and state functions.",
        questionTypes: [BankQuestionType.multiple],
        questionCount: 60,
        updatedAt: "2024-09-24T09:00:00Z",
        coursesInUse: [
            { id: '1', name: 'Comprehensive Guide to Machine Learning and Artificial Intelligence' },
            { id: '2', name: 'Advanced Topics in Quantum Computing and Cryptography Applications' },
            { id: '3', name: 'Deep Dive into Neuroscience: Brain Functionality and Cognitive Science' },
            { id: '4', name: 'Exploring the Frontiers of Astrobiology and Extraterrestrial Life Research' },
            { id: '5', name: 'Strategic Management in the Era of Digital Transformation and Innovation' }
        ]
    },
    {
        id: "12",
        name: "A Detailed Survey of Renaissance Art and Its Cultural Impact on the Evolution of Western Civilization from the 14th to the 17th Century",
        description: "This collection of questions encompasses an in-depth study of Renaissance art, exploring the works of great masters such as Leonardo da Vinci, Michelangelo, and Raphael, and analyzing how their innovations in perspective, human anatomy, and use of light reshaped the course of Western art history.",
        questionTypes: [BankQuestionType.survey, BankQuestionType.relation],
        questionCount: 45,
        updatedAt: "2024-09-23T10:20:00Z",
        coursesInUse: []
    },
    {
        id: "13",
        name: "The Intricacies of Modern Cryptographic Algorithms and Their Applications in Securing Digital Communications and Blockchain Technologies",
        description: "This extensive set of questions covers the various cryptographic algorithms that are essential for securing digital communications, including symmetric encryption, public-key infrastructure, hash functions, and their implementation in modern technologies like blockchain, cryptocurrencies, and digital certificates.",
        questionTypes: [BankQuestionType.multiple],
        questionCount: 38,
        updatedAt: "2024-09-22T11:45:00Z",
        coursesInUse: [
            { id: '1', name: 'Algebraic Topology' },
            { id: '2', name: 'Introduction to Philosophy' }
        ]
    },
    {
        id: "14",
        name: "An Exhaustive Study of Global Environmental Policy and Its Role in Mitigating the Adverse Effects of Climate Change and Biodiversity Loss",
        description: "This question bank explores global environmental policies, focusing on international agreements such as the Paris Agreement, their role in combating climate change, reducing carbon emissions, and protecting biodiversity, while also addressing socio-economic impacts on various regions.",
        questionTypes: [BankQuestionType.survey],
        questionCount: 50,
        updatedAt: "2024-09-21T13:10:00Z",
        coursesInUse: [
            { id: '1', name: 'Quantum Field Theory' },
            { id: '2', name: 'Neuroscience of Decision Making' },
            { id: '3', name: 'Modern Art and Visual Culture' },
            { id: '4', name: 'Advanced Data Science and Machine Learning' },
            { id: '5', name: 'Philosophy of Science' },
            { id: '6', name: 'Environmental Economics' },
            { id: '7', name: 'Global Health and Infectious Diseases' },
            { id: '8', name: 'Cognitive Psychology' },
            { id: '9', name: 'Digital Marketing Strategies' },
            { id: '10', name: 'Bioinformatics and Computational Biology' }
        ]
    },
    {
        id: "15",
        name: "The Evolution of Information Technology Infrastructure in the Digital Age: From Mainframes to Cloud Computing and Beyond",
        description: "This comprehensive question bank explores the history and evolution of information technology infrastructure, focusing on key milestones such as the development of mainframes, personal computers, the internet, and cloud computing, along with future trends in IT infrastructure and its societal impact.",
        questionTypes: [BankQuestionType.relation, BankQuestionType.multiple],
        questionCount: 72,
        updatedAt: "2024-09-20T14:30:00Z",
        coursesInUse: []
    },
    {
        id: "16",
        name: "A Broad Analysis of Socioeconomic Factors Affecting Global Health Disparities and the Role of Public Health Initiatives in Alleviating Inequality",
        description: "This set of questions examines the various socioeconomic factors, such as income inequality, education, and access to healthcare, that contribute to global health disparities, and analyzes how public health initiatives, governmental policies, and international organizations are working to alleviate these inequalities.",
        questionTypes: [BankQuestionType.survey],
        questionCount: 55,
        updatedAt: "2024-09-19T15:40:00Z",
        coursesInUse: []
    },
    {
        id: "17",
        name: "The Deep Impact of Technological Innovation in the 21st Century on Global Economies and Societal Structures: A Multidisciplinary Approach",
        description: "This collection examines the profound influence of technological innovations such as artificial intelligence, machine learning, and automation on the global economy, including job displacement, creation of new industries, and the broader implications for societal structures and governance.",
        questionTypes: [BankQuestionType.relation, BankQuestionType.multiple],
        questionCount: 63,
        updatedAt: "2024-09-18T16:15:00Z",
        coursesInUse: []
    },
    {
        id: "18",
        name: "A Critical Examination of Ancient Philosophies and Their Continuing Influence on Modern Ethical and Political Thought",
        description: "This question bank provides a detailed exploration of ancient philosophical traditions such as Stoicism, Confucianism, and Platonism, tracing their influence on modern ethical theories and political systems, and exploring the continuing relevance of these ideas in contemporary discourse.",
        questionTypes: [BankQuestionType.multiple, BankQuestionType.survey],
        questionCount: 48,
        updatedAt: "2024-09-17T17:25:00Z",
        coursesInUse: []
    },
    {
        id: "19",
        name: "The Global Financial System: Understanding the Complex Interactions Between Central Banks, International Trade, and Emerging Markets",
        description: "This bank delves into the complexities of the global financial system, focusing on the roles of central banks, international trade policies, and the rise of emerging markets, and provides insight into the challenges of maintaining economic stability in a globalized world.",
        questionTypes: [BankQuestionType.relation],
        questionCount: 58,
        updatedAt: "2024-09-16T18:40:00Z",
        coursesInUse: []
    },
    {
        id: "20",
        name: "The History and Evolution of the Human Rights Movement: From the Magna Carta to the Universal Declaration of Human Rights",
        description: "This question set examines the history of human rights movements, starting from the Magna Carta, tracing significant developments through the French Revolution, the abolition of slavery, and culminating in the modern framework provided by the United Nations' Universal Declaration of Human Rights.",
        questionTypes: [BankQuestionType.survey],
        questionCount: 30,
        updatedAt: "2024-09-15T19:55:00Z",
        coursesInUse: []
    }
];


export const questionFormMock: BankData = {
    "name": "Banco de Preguntas Test #01",
    "description": "Este banco de preguntas en un mock para hacer pruebas.",
    "questions": [
        {
            id: "q1",
            "index": 1,
            "text": "<p>¿Cuál es la capital de Francia?</p>",
            "type": BankQuestionType.multiple,
            "options": [
                {
                    "index": 1,
                    "text": "París",
                    "explanation": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>",
                    "correct": true
                },
                {
                    "index": 2,
                    "text": "Roma",
                    "explanation": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>",
                    "correct": false
                },
                {
                    "index": 3,
                    "text": "Berlín",
                    "explanation": "",
                    "correct": false
                },
                {
                    "index": 4,
                    "text": "Madrid",
                    "explanation": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>",
                    "correct": false
                }
            ]
        },
        {
            id: "q2",
            "index": 2,
            "text": "<p>Relaciona los siguientes países con sus capitales</p>",
            "type": BankQuestionType.relation,
            "options": [
                {
                    "index": 1,
                    "text": "Francia",
                    "explanation": "París",
                    "correct": false
                },
                {
                    "index": 2,
                    "text": "Italia",
                    "explanation": "Roma",
                    "correct": false
                },
                {
                    "index": 3,
                    "text": "Alemania",
                    "explanation": "Berlín",
                    "correct": false
                },
                {
                    "index": 4,
                    "text": "España",
                    "explanation": "Madrid",
                    "correct": false
                }
            ]
        },
        {
            id: "q3",
            "index": 3,
            "text": "<p>¿Qué tan satisfecho estás con nuestro servicio?</p>",
            "type": BankQuestionType.survey,
            "options": [
                {
                    "index": 1,
                    "text": "Muy satisfecho",
                    "explanation": "",
                    "correct": false
                },
                {
                    "index": 2,
                    "text": "Satisfecho",
                    "explanation": "",
                    "correct": false
                },
                {
                    "index": 3,
                    "text": "Neutral",
                    "explanation": "",
                    "correct": false
                },
                {
                    "index": 4,
                    "text": "Insatisfecho",
                    "explanation": "",
                    "correct": false
                },
                {
                    "index": 5,
                    "text": "Muy insatisfecho",
                    "explanation": "",
                    "correct": false
                },
                {
                    "index": 6,
                    "text": "No puedo creerlo",
                    "explanation": "",
                    "correct": false
                }
            ]
        },
        {
            id: "q4",
            "index": 4,
            "text": "<p>¿Cuál de los siguientes es un lenguaje de programación?</p>",
            "type": BankQuestionType.multiple,
            "options": [
                {
                    "index": 1,
                    "text": "JavaScript",
                    "explanation": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>",
                    "correct": true
                },
                {
                    "index": 2,
                    "text": "HTML",
                    "explanation": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>",
                    "correct": false
                },
                {
                    "index": 3,
                    "text": "CSS",
                    "explanation": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>",
                    "correct": false
                },
                {
                    "index": 4,
                    "text": "SQL",
                    "explanation": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>",
                    "correct": false
                }
            ]
        },
        {
            id: "q5",
            "index": 5,
            "text": "<p>¿Cuáles de estas son fuentes de energía renovable?</p>",
            "type": BankQuestionType.multiple,
            "options": [
                {
                    "index": 1,
                    "text": "Solar",
                    "explanation": "",
                    "correct": true
                },
                {
                    "index": 2,
                    "text": "Viento",
                    "explanation": "",
                    "correct": false
                },
                {
                    "index": 3,
                    "text": "Carbón",
                    "explanation": "",
                    "correct": false
                },
                {
                    "index": 4,
                    "text": "Petróleo",
                    "explanation": "",
                    "correct": false
                }
            ]
        }
    ]
}